import { CONSOLIDATION_API } from '../constants';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getConsolidationLink:
    (id, onSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(
        `${
          CONSOLIDATION_API.accessLink
        }/${id}/access-link?type=${encodeURIComponent('Consolidated')}`
      );
      status === 200 && onSuccess(result);
    },
};

const corporateConsolidationReportDispatcher = synthesize(
  'corporateConsolidationReport',
  mapDispatchToAC
);
export default corporateConsolidationReportDispatcher;
